"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = getFmpMaxImgTime;

require("core-js/modules/es.function.name.js");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _every = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/every"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getImgForFmp = _interopRequireDefault(require("./getImgForFmp"));

/**
 * @file 获取首屏时间
 * @author zhangyanting
 */

/**
 * 首屏图片是否都加载完成
 * @param {Object} fsImgLoadList  首屏图片列表
 * @private
 */
function getMaxImgTimeIfImgAllLoaded(fsImgLoadList) {
  var _context;

  var isAlLoaded = (0, _every.default)(_context = (0, _keys.default)(fsImgLoadList)).call(_context, function (item) {
    return fsImgLoadList[item].load === true;
  });
  var maxImgTime = 0;

  if (isAlLoaded) {
    maxImgTime = getImgMaxTime(fsImgLoadList);
    fsImgLoadList = {};
  }

  return {
    isAlLoaded: isAlLoaded,
    maxImgTime: maxImgTime
  };
}
/**
 * 获取最大的图片加载时长
 * @param {Object} imgs 首屏图片列表
 */


function getImgMaxTime(imgs) {
  var _context2;

  if (!imgs || (0, _keys.default)(imgs).length === 0) {
    return 0;
  }

  var imgTimes = (0, _map.default)(_context2 = (0, _keys.default)(imgs)).call(_context2, function (element) {
    return imgs[element].time;
  });
  return Math.max.apply(Math, (0, _toConsumableArray2.default)(imgTimes));
}
/**
 * 获取首屏时间
 * @param {string} option.mainImgUrl 依赖的主要图片地址
 */


function getFmpMaxImgTime(_ref) {
  var _ref$mainImgUrl = _ref.mainImgUrl,
      mainImgUrl = _ref$mainImgUrl === void 0 ? '' : _ref$mainImgUrl;
  var fsTimeObj = {
    mainImg: {
      startTime: null,
      endTime: null,
      duration: null
    },
    fsEndTime: 0
  };
  return new _promise.default(function (resolve, reject) {
    var imgs = (0, _getImgForFmp.default)(document.body).imgSrcs;
    var fsImgLoadList = {}; // 统计下首屏多少个图片

    fsTimeObj.count = imgs.length;
    (0, _forEach.default)(imgs).call(imgs, function (item) {
      fsImgLoadList[item] = {
        load: false,
        time: 0
      };

      try {
        var isLoaedImgEnrtry = window.performance.getEntriesByName(item);

        if (isLoaedImgEnrtry[0]) {
          fsImgLoadList[item] = {
            load: true,
            time: isLoaedImgEnrtry[0].responseEnd
          };
        } else {
          fsImgLoadList[item] = {
            load: false,
            time: 0
          };
        }
      } catch (error) {
        return 0;
      }
    });

    var _getMaxImgTimeIfImgAl = getMaxImgTimeIfImgAllLoaded(fsImgLoadList),
        isAlLoaded = _getMaxImgTimeIfImgAl.isAlLoaded,
        maxImgTime = _getMaxImgTimeIfImgAl.maxImgTime;

    if (isAlLoaded) {
      fsTimeObj.fsEndTime = maxImgTime; // 所有图片的responseEnd时间跟计算的fmp相比较得出最大值

      resolve(fsTimeObj);
    }

    var observer = new window.PerformanceObserver(function (list) {
      try {
        var perfEntries = list.getEntries();

        for (var i = 0; i < perfEntries.length; i++) {
          var entryItem = perfEntries[i];
          var sourceURL = entryItem.name;

          if (entryItem.initiatorType === 'img' && fsImgLoadList[sourceURL]) {
            fsImgLoadList[sourceURL].load = true; // 距离navigationStart的差值

            fsImgLoadList[sourceURL].time = entryItem.responseEnd;

            if (mainImgUrl === sourceURL) {
              fsTimeObj.mainImg = {
                startTime: entryItem.startTime,
                endTime: entryItem.responseEnd,
                duration: entryItem.duration
              };
            }

            var _getMaxImgTimeIfImgAl2 = getMaxImgTimeIfImgAllLoaded(fsImgLoadList),
                _isAlLoaded = _getMaxImgTimeIfImgAl2.isAlLoaded,
                _maxImgTime = _getMaxImgTimeIfImgAl2.maxImgTime;

            if (_isAlLoaded) {
              fsTimeObj.fsEndTime = _maxImgTime; // 所有图片的responseEnd时间跟计算的fmp相比较得出最大值

              resolve(fsTimeObj);
            }
          }
        }
      } catch (e) {
        console.log(e);
        reject(0);
      }
    }); // 注册资源观察者

    observer.observe({
      entryTypes: ['resource']
    });
  });
}